import {ConfiguracaoPlano} from "./configuracao-plano";

export class ConfiguracaoGrupoPlano {

	static SIGLA_APRESENTACAO = "APR";

	public cod_configuracao_grupo_plano: number;
	public dsc_configuracao_grupo_plano: string;
	public sgl_configuracao_grupo_plano: string;
	public num_ordem: number;
	public qtd_configuracoes_plano: number = 0;
	public qtd_configuracoes_plano_respondidas: number = 0;
	public configuracoes_plano: Array<ConfiguracaoPlano>;
}
